export type CustomResultItemField = {
  id: number;
  field: string;
  value: string;
};

export const parseCustomFieldsJson = (customFields: any) => {
  const parsedCustomFields: CustomResultItemField[] = [];
  if (customFields) {
    Object.entries(customFields).forEach(([key], index: number) => {
      const value: any = customFields[key];
      const customField: CustomResultItemField = {
        // forces the customField id to always reorder
        id: index + 1,
        field: value.name,
        value: value.value,
      };

      parsedCustomFields.push(customField);
    });
  }
  return parsedCustomFields;
};

export const removeCustomField = (
  customField: CustomResultItemField,
  customFields: CustomResultItemField[],
  setCustomFields: React.Dispatch<React.SetStateAction<CustomResultItemField[]>>,
) => {
  const currentFields = [...customFields];
  const newCustomFields: CustomResultItemField[] = [];
  currentFields.forEach((currentField) => {
    if (currentField.id === customField.id) {
      return true;
    }
    if (currentField.id > customField.id) {
      currentField.id -= 1;
    }

    newCustomFields.push(currentField);
    return true;
  });

  setCustomFields(newCustomFields);
};

export const updateCustomField = (
  customField: CustomResultItemField,
  customFields: CustomResultItemField[],
  setCustomFields: React.Dispatch<React.SetStateAction<CustomResultItemField[]>>,
) => {
  const currentFields = [...customFields];
  const newCustomFields: CustomResultItemField[] = [];
  currentFields.forEach((currentField) => {
    if (currentField.id === customField.id) {
      newCustomFields.push(customField);
      return true;
    }

    newCustomFields.push(currentField);
    return true;
  });

  setCustomFields(newCustomFields);
};

export const handleNewCustomFieldButtonClick = (
  customFields: CustomResultItemField[],
  setCustomFields: React.Dispatch<React.SetStateAction<CustomResultItemField[]>>,
) => {
  const currentFields = [...customFields];
  currentFields.push({
    id: customFields.length + 1,
    field: '',
    value: '',
  });
  setCustomFields(currentFields);
};
